import React, { FunctionComponent } from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Hint from '@components/basics/hint';

interface PreviewHintProps {
  className?: string;
  isMobile?: boolean;
}

const PreviewHint: FunctionComponent<PreviewHintProps> = ({
  className,
  isMobile,
}) => {
  return (
    <Hint
      className={className || ''}
      noBorderTop={isMobile}
      noMargin
      isSmall
      align="left"
      customBorderRadius="10px"
      customTitle={<Translate id="RELEASE.PREVIEW.HINT.TITLE" />}
    >
      <ul>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.BLURRY" />
        </li>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.FEAT" />
        </li>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.PROD" />
        </li>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.MISSPELLED" />
        </li>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.LOGOS" />
        </li>
        <li>
          <Translate id="RELEASE.PREVIEW.HINT.TEXT.EXTRA" />
        </li>
      </ul>
    </Hint>
  );
};

export default styled(PreviewHint)`
  width: 100%;

  ul {
    margin-top: 10px;
    padding-left: 15px;

    li {
      margin-bottom: 10px;
      color: ${({ theme }) => theme.colors.black};
      font-size: ${({ theme }) => theme.typography.span};

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
